import { Player, Team, Event } from './../../interfaces';
import dayjs from 'dayjs';
dayjs().format();
import App from '~/core/app'
import { ICore } from '~/core/core'; // type from the future
const core = App.Core<ICore>(); // grab sister controller

export const state = {
}
export const computed = {
    completed: App.Computed<Event[]>(()=> {
        collection.getGroup('default').build()
        return collection.getGroup('default').output.filter(event => dayjs(event.date).isBefore(Date.now(), 'minute'))
    }),
    upcoming: App.Computed<Event[]>(()=> {
        collection.getGroup('default').build()
        return collection.getGroup('default').output.filter(event => dayjs(event.date).isAfter(Date.now(), 'minute'))
    }),
    sortedByDate: App.Computed<Event[]>(()=> {
        collection.getGroup('default').build()
        core.user.state.canCreateEvent.recompute()
        const events = collection.getGroup('default').output.sort((event1, event2) => dayjs(event1.date).isAfter(event2.date, 'minute') ? -1 : 1)
        
        if(core.user.state.canCreateEvent.value){
            //' the user is an admin... so they can see all events
            return events
        }
        else{
            return events.filter((event) => event.status !== "INIT")
        }
       
    }),
    viewable: App.Computed(() =>  collection.selectors.focused.value?.status==='PUBLISHED' || collection.selectors.focused.value?.status==='RUNNING'),
    isRunning: App.Computed(() => collection.selectors.focused.value?.status === 'RUNNING'),
    isPublished: App.Computed(() => collection.selectors.focused.value?.status === 'PUBLISHED'),
    isInit: App.Computed(() => collection.selectors.focused.value?.status === 'INIT'),
    isCompleted: App.Computed(() => collection.selectors.focused.value?.status === 'COMPLETED'),

}
export const collection = App.Collection<Event>()(coll => ({
    defaultGroup: true,
    groups: {
        published: coll.Group(),
        pending: coll.Group(),
    },
    selectors: {
        focused: coll.Selector()
    }
}))
